import { FC } from "react";

import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import { brandColorTokens } from "@constants";

const CartEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, p: 5 }}>
      <ShoppingCartOutlinedIcon sx={{ fontSize: 40, color: brandColorTokens.icon.subtle }} />
      <Typography color="text.secondary" textAlign="center">
        {t("cart.noItems")}
      </Typography>
    </Box>
  );
};

export default CartEmptyState;
